/** Context bindings — create view (delegates to the shared form). */
import { ContextBindingForm } from "./_ContextBindingForm";

export function ContextBindingCreate() {
  return <ContextBindingForm action="create" />;
}

export default ContextBindingCreate;
